// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Analytics = registerClientReference(
    function() { throw new Error("Attempted to call Analytics() from the server but Analytics is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/.pnpm/@vercel+analytics@1.3.1_nex_02236ad1b174b2b55b3531d68fd28194/node_modules/@vercel/analytics/dist/next/index.mjs <module evaluation>",
    "Analytics",
);
